<div class="card" [ngClass]="cardClasses">
  <div class="header"><ng-content select="[card-header]"></ng-content></div>
  <div class="content"><ng-content select="[card-content]"></ng-content></div>
</div>
